import { Input } from "antd";
import { AvoidSpace, PreventPasting } from "../../Shared/Methods";
import { lengths } from "../../Shared/Constants";
import Commonformlabel from "./CommonFormLabel";
import Commonformerror from "./CommonFormError";

interface props {
  name: string;
  values?: any;
  onChange?: (value: any) => void;
  required?: boolean;
  error?: any;
  touched?: any;
  labelname?: string;
  type?: "password" | "number" | "text";
  onBlur?: any;
  isInvalid?: any;
  size?: any;
}

function CommonPasswordInput({
  values,
  required = false,
  name,
  onChange,
  error,
  labelname,
  touched,
  onBlur,
  type,
  isInvalid,
  size = "middle",
}: props) {
  return (
    <>
      <Commonformlabel labelname={labelname} required={required} />

      <Input.Password
        name={name}
        value={values}
        onChange={onChange}
        onPaste={PreventPasting}
        maxLength={lengths.Password}
        onKeyDown={AvoidSpace}
        type={type}
        placeholder={labelname}
        onBlur={onBlur}
        size={size}
      />
      <Commonformerror
        required={required}
        touched={touched}
        name={name}
        error={error}
      />
    </>
  );
}

export default CommonPasswordInput;
